// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
var Adder = /** @class */ (function () {
    function Adder() {
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    Adder.prototype.add = function (x) {
        var p = this._partials;
        var i = 0;
        for (var j = 0; j < this._n && j < 32; j++) {
            var y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo)
                p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    };
    Adder.prototype.valueOf = function () {
        var p = this._partials;
        var n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while (n > 0) {
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo)
                    break;
            }
            if (n > 0 && ((lo < 0 && p[n - 1] < 0) || (lo > 0 && p[n - 1] > 0))) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi)
                    hi = x;
            }
        }
        return hi;
    };
    return Adder;
}());
export { Adder };
export function fsum(values, valueof) {
    var adder = new Adder();
    if (valueof === undefined) {
        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
            var value = values_1[_i];
            if (value = +value) {
                adder.add(value);
            }
        }
    }
    else {
        var index = -1;
        for (var _a = 0, values_2 = values; _a < values_2.length; _a++) {
            var value = values_2[_a];
            if (value = +valueof(value, ++index, values)) {
                adder.add(value);
            }
        }
    }
    return +adder;
}
export function fcumsum(values, valueof) {
    var adder = new Adder();
    var index = -1;
    return Float64Array.from(values, valueof === undefined
        ? function (v) { return adder.add(+v || 0); }
        : function (v) { return adder.add(+valueof(v, ++index, values) || 0); });
}
